import React from 'react'
import { Canvas } from '@react-three/fiber'
import {
  Decal, Float, OrbitControls, Preload, useTexture
} from "@react-three/drei"
import { Suspense } from 'react'
import CanvasLoader from "../Loader"

const Ball = (props) => {
  const [decal] = useTexture([props.imageUrl])

  return (
    <Float speed={1.75} rotationIntensity={1} floatIntensity={2}>
    <ambientLight intensity={0.8}/>
    <directionalLight position={[0,0,0.05]}/>
    <mesh castShadow receiveShadow scale={2.75}>
    <icosahedronGeometry args={[1,1]} />
   <meshStandardMaterial
     color="white"
     polygonOffset
     polygonOffsetFactor={-5}
     flatShading
    />
    <Decal
     position={[0,0,0.5]} 
     rotation={[2*Math.PI ,0 ,6.25]}
     flatShading
     map={decal}
    />
    </mesh>
    </Float>
  )
}

const BallCanvas = ({ icon }) => {
  return (

    <Canvas
      frameloop='demand'
     gl={{ preserveDrawingBuffer: true }}
    >
      <Suspense fallback={<CanvasLoader />}>
        <OrbitControls
          enableZoom={false}
        />
        <Ball imageUrl = {icon}/>
      </Suspense>
      <Preload all />
    </Canvas>

  )
}

export default BallCanvas